module.exports = __webpack_public_path__ + "static/media/grilled-cheese.fdc0f725.svg";